import React, { useState } from "react"
import { Link as BaseLink } from "react-router-dom"
import styled from "styled-components"
import styles from "../../styles"
import Avatar from "../Avatar"
import { useAuth } from "../../hooks/context/auth"
import { useUi } from "../../hooks/context/ui"
import { SIDEBAR_WIDTH } from "../Sidebar/Sidebar"
import { useNavigate } from "react-router"
import { FaPlus, FaSearch } from "react-icons/fa"
import { CDN_URL } from "../../config/games"
import { BiUserCircle } from "react-icons/bi"

const Header = () => {
  const navigate = useNavigate()
  const { sidebarTab, setSidebarTab, isEditingNewMarker, setIsEditingNewMarker } = useUi()
  const { user } = useAuth()

  const [iconButtonHover, setIconButtonHover] = useState(false)
  return (
    <Root>
      <Left sidebarTab={sidebarTab}>
        <LogoLink to="/" title="Back to MapSpot">
          <span style={{ fontSize: 14, fontWeight: 700, letterSpacing: '0.5px' }}>📍</span>
        </LogoLink>
        <IconButton
          onClick={() => {
            if (sidebarTab !== "categories") setSidebarTab("categories")
            else {
              setSidebarTab(false)
            }
          }}
          onMouseEnter={() => setIconButtonHover(true)}
          onMouseLeave={() => setIconButtonHover(false)}
        >
          <img
            alt="map-compass"
            src={iconButtonHover ? `${CDN_URL}/assets/icons/compass.png` : `${CDN_URL}/assets/icons/compass-1.png`}
            width={30}
            height={30}
          />
          <span style={{ marginBottom: 1 }}>Map</span>
        </IconButton>
        <IconButton
          onClick={() => {
            if (sidebarTab !== "search") setSidebarTab("search")
            else {
              setSidebarTab(false)
            }
          }}
        >
          <FaSearch />
          <span>Search</span>
        </IconButton>
        <IconButton as={Link} to={"/account"}>
          {user ? (
            <UserCircle>
              <Avatar size={20} seed={user.email} />
            </UserCircle>
          ) : (
            <BiUserCircle size={20} />
          )}
          <span>Account</span>
        </IconButton>
        <IconButton
          as="button"
          onClick={() => {
            if (!user) {
              return navigate("/account")
            }
            return setIsEditingNewMarker(!isEditingNewMarker)
          }}
        >
          <FaPlus size={18} />
          <span>Marker</span>
        </IconButton>
      </Left>
    </Root>
  )
}

const Root = styled.div`
  pointer-events: none;
  padding-left: 10px;
  padding-right: 10px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  position: fixed;
  top: 0;
  left: 0;
  height: 60px;
  z-index: 10;
  width: 100%;
`

const Left = styled.div<{ sidebarTab: string | false }>`
  ${(props) => props.theme.clip.default}
  display: flex;
  pointer-events: all;
  transition: all 0.3s;
  background-color: ${({ theme }) => theme.colors.primaryDark};
  min-width: ${({ sidebarTab }) => SIDEBAR_WIDTH + (sidebarTab ? 16 : -50)}px;
  height: 34px;
`

const UserCircle = styled.div`
  padding: 0;
  display: inline-block;
  border-radius: 50%;
  cursor: pointer;

  svg,
  img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }
`

const LogoLink = styled(BaseLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  height: 34px;
  color: ${styles.colors.white};
  text-decoration: none;
  opacity: 0.6;
  transition: opacity 0.15s;
  &:hover {
    opacity: 1;
    background-color: ${styles.colors.primaryHighlight};
  }
`

const Link = styled(BaseLink)`
  color: ${styles.colors.white};
  text-decoration: none;
  font-size: 1rem;
  &:hover {
    background-color: ${styles.colors.primaryHighlight};
  }
`

const IconButton = styled.a`
  padding: 0 5px;
  height: 34px;
  display: flex;
  align-items: center;
  vertical-align: middle;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: ${styles.colors.white};
  text-decoration: none;
  font-size: 1rem;
  span {
    margin-left: 5px;
    vertical-align: middle;
  }
  &:hover {
    background-color: ${styles.colors.primaryHighlight};
  }
`

export default Header
